import classNames from "classnames";
import { CmsResponsiveImage } from "components/CmsResponsiveImage";
import { BaseDialogProps } from "components/Favorites/interfaces";
import { Modal } from "components/Modal";
import { RichTextContent } from "components/RichText";
import { imagePlaceholder } from "helpers/utils";
import {
    AttributeOptionFunction,
    FunctionModalItem as Props,
} from "interfaces/products";
import { Heading } from "react-aria-components";

import styles from "./product-functions-modal.module.scss";

export const FunctionModalItem = ({ title, image, description }: Props) => (
    <li className={styles.listItem}>
        <CmsResponsiveImage
            decorative={true}
            cmsImage={image ? image : { url: imagePlaceholder }}
            className={styles.image}
            sizes="200px"
            cldSrcSet={[120, 240, 360, 480]}
            cloudinaryProps={{
                aspectRatio: "1:1",
                crop: "fill",
                type: image ? "fetch" : "upload",
            }}
        />
        <h2 className={classNames(["h6", styles.itemHeading])}>{title}</h2>
        {description !== "" && (
            <RichTextContent
                className={styles.richText}
                richText={description}
            />
        )}
    </li>
);

export interface FunctionModalProps extends BaseDialogProps {
    functions: AttributeOptionFunction[];
}

export const FunctionModal = ({ functions }: FunctionModalProps) => (
    <Modal width="full" padding="column">
        <Heading
            level={1}
            className={classNames(["h4", styles.header])}
            id="product-functions-modal"
        >
            Functions
        </Heading>
        <ul className={styles.list}>
            {functions.map((item, index) => {
                const props: Props = item.function_modal ?? {
                    title: item.option,
                    image: null,
                    description: "",
                };
                return <FunctionModalItem key={index} {...props} />;
            })}
        </ul>
    </Modal>
);
